import { inject } from "mobx-react";
import React, { ReactNode } from "react";
import { IndexView } from "lego-gui-lib/lib";
import { ReportsMonthlySchemaColumns, ReportsSchemaColumns } from "./schema";
import {
  TabContentContainer,
  TabTitleContainer,
  TabViewContainer
} from "../../../common/tabContainers";
import { customRowButtons } from "./customRowButtons";
import { I18n, TextField, withBreadCrumbs } from "lego-gui-lib";
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";
import InsertDriveFileOutlined from "@material-ui/icons/InsertDriveFileOutlined";
import { IconButton, Tooltip } from "@material-ui/core";
import { MonthlyReportComponent, ReportComponent } from "./ReportsComponent";
import { ReportDetailsDefinitionSchema } from "../../reportDefinition/schema";
import { t } from "../../../core/i18n/i18n";
import { observer } from "mobx-react-lite";
import { Auth } from "../../../core/model/auth";

const injectDataSource = (comp: any) =>
  inject("report", "reportMonthly", "i18n", "commons")(observer(comp));

export const IndexReports = injectDataSource(
  ({ report, i18n, match, commons, ...rest }: any) => {
    const indexTitle = i18n.t("hns:report:daily");
    return (
      <IndexView
        dataSource={report.listDataSource}
        {...rest}
        disableCheckboxes={true}
        rowButtons={customRowButtons}
        titleButtons={() => <></>}
        title={indexTitle}
        columns={ReportsSchemaColumns}
        titleVariant={"h5"}
        titleContainer={TabTitleContainer}
        viewContainer={TabViewContainer}
        contentContainer={TabContentContainer}
      />
    );
  }
);

export const IndexReportsMonthly = injectDataSource(
  ({ reportMonthly, i18n, match, commons, ...rest }: any) => {
    const indexTitle = i18n.t("hns:report:monthly");

    return (
      <IndexView
        dataSource={reportMonthly.listDataSource}
        {...rest}
        disableCheckboxes={true}
        rowButtons={customRowButtons}
        titleButtons={() => <></>}
        title={indexTitle}
        columns={ReportsMonthlySchemaColumns}
        titleVariant={"h5"}
        titleContainer={TabTitleContainer}
        viewContainer={TabViewContainer}
        contentContainer={TabContentContainer}
      />
    );
  }
);

export const titleButtons = (
  dataSource: any,
  id: string,
  i18n: I18n
): ReactNode => {
  const pdf = i18n.t("hns:report:pdf");
  const csv = i18n.t("hns:report:csv");

  const getAsCsv = () => {
    dataSource.getAsCsv(id);
  };

  const getAsPdf = () => {
    dataSource.getAsPdf(id);
  };

  return (
    <>
      <Tooltip title={pdf}>
        <IconButton onClick={getAsPdf} key={"pdf"} color={"primary"}>
          <PictureAsPdf />
        </IconButton>
      </Tooltip>
      <Tooltip title={csv}>
        <IconButton onClick={getAsCsv} key={"csv"} color={"primary"}>
          <InsertDriveFileOutlined />
        </IconButton>
      </Tooltip>
    </>
  );
};

export const ReportDetails = injectDataSource(
  ({ report, i18n, match, ...rest }: any) => {
    const title =
      i18n.t("hns:report:details") + " - " + i18n.t("hns:report:daily");
    const baseUrl = match.url;
    const extSchema = ReportDetailsDefinitionSchema("", TextField());
    extSchema.security = {
      ...extSchema.security,
      readableRole: Auth.Roles.ANYONE,
      editableRole: Auth.Roles.ANYONE_WITH_WRITE
    };
    extSchema.fields.unshift({
      title: t("hns:reportDefinition:time"),
      name: "time",
      type: TextField(),
      filter: false,
      sort: false,
      width: "150px"
    });

    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <ReportComponent
        {...rest}
        dataSource={report.oneDataSource}
        customButtons={titleButtons(
          report.listDataSource,
          match.params.id,
          i18n
        )}
        title={title}
        fields={extSchema}
        id={match.params}
      />
    );
  }
);

export const ReportDetailsMonthly = injectDataSource(
  ({ reportMonthly, i18n, match, ...rest }: any) => {
    const title = i18n.t("hns:report:monthly");
    const baseUrl = match.url;

    const extSchema = ReportDetailsDefinitionSchema("", TextField());
    extSchema.security = {
      ...extSchema.security,
      readableRole: Auth.Roles.ANYONE,
      editableRole: Auth.Roles.ANYONE_WITH_WRITE
    };
    extSchema.fields.unshift({
      title: t("hns:reportDefinition:time"),
      name: "time",
      type: TextField(),
      filter: false,
      sort: false,
      width: "150px"
    });

    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <MonthlyReportComponent
        {...rest}
        dataSource={reportMonthly.oneDataSource}
        customButtons={titleButtons(
          reportMonthly.listDataSource,
          match.params.id,
          i18n
        )}
        title={title}
        fields={extSchema}
        id={match.params}
      />
    );
  }
);
